import React from 'react'

const Message = props => (
  <div className={props.classNames} role="alert">
    <button
      type="button"
      className="close"
      onClick={props.onDismiss}
    >
    <span className="myob-icon-close icon-close-alert"></span>
    </button>
    <span>{props.text}</span>
  </div>
)

Message.propTypes = {
  classNames: React.PropTypes.string.isRequired,
  text: React.PropTypes.string.isRequired,
  onDismiss: React.PropTypes.func.isRequired
}

export default Message



// WEBPACK FOOTER //
// ./src/app/components/Message.js